import React, { useEffect, useState } from "react";
import { Modal, Form, Radio } from "antd";
import { useForm } from "antd/es/form/Form";
import { SuccessPopup, ErrorPopup } from "../../../../utilities/swal";
import { createBusApi } from "../../../../apis/bus.api";

interface ModalAddBusProps {
  visible: boolean;
  onClose: () => void;
  tripId: string;
  /** Optional callback called after successful add */
  onSuccess?: () => void;
}

const ModalAddBus: React.FC<ModalAddBusProps> = (props: ModalAddBusProps) => {
  const { onClose, visible, tripId, onSuccess } = props;
  const [loading, setLoading] = useState(false);
  const [form] = useForm();

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      // expected payload: { busType: number }
      const payload = { busType: Number(values.busType) };
      const rs = await createBusApi(tripId, payload.busType);
      if (rs && rs.success) {
        form.resetFields();

        onSuccess && onSuccess();
        onClose && onClose();
      } else {
        ErrorPopup("Thêm xe thất bại", rs?.message || "");
      }
    } catch (error: any) {
      ErrorPopup("Thêm xe thất bại", error?.message || "");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible) {
      return () => {
        form.resetFields();
      };
    }
  }, [visible, form]);

  return (
    <Modal
      loading={loading}
      title="Thêm xe"
      open={visible}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={loading}
    >
      <Form
        disabled={loading}
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        initialValues={{ busType: 29 }}
        className="mt-3"
      >
        <Form.Item
          name="busType"
          label="Chọn loại xe"
          rules={[{ required: true, message: "Vui lòng chọn loại xe" }]}
        >
          <Radio.Group>
            <Radio value={16}>16 chỗ</Radio>
            <Radio value={29}>29 chỗ</Radio>
            <Radio value={45}>45 chỗ</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAddBus;
